import {useState} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'
import {VideoForm, VideoIconButton, FollowButton} from '../../generics'


const styles = {
  videoContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    background-color: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    flex: 0 0 60px;
    z-index: 15;
    padding: 8px;

    svg {
      width: 30px;
      height: 30px;
    }
  `
}

const ArtistDetailMainButton = ({ artistId, isOwner }) => {
  const [open, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  return isOwner ? (
    <div css={styles.videoContainer}>
      <VideoIconButton open={open} setOpen={setOpen}>
        <VideoForm id={artistId} type='artist' close={handleClose} />
      </VideoIconButton>
    </div>
  ) : (
    <FollowButton id={artistId} type='artist' />
  )
}


export default ArtistDetailMainButton